// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Button,
//   Chip,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Divider,
//   Grid,
//   IconButton,
//   Paper,
//   Tooltip,
//   Typography
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router-dom";
// import { IoEyeOutline } from "react-icons/io5";
// import { CiRepeat } from "react-icons/ci";
// import { GoDownload } from "react-icons/go";
// import { AiTwotoneDelete } from "react-icons/ai";
// import Swal from "sweetalert2";
// import CountryFlag from "../../customComponent/CountryFlag";

// // Actions
// import { CommonDocumentApplicationFindAction } from "../../../actions/knowledgeBankActions/CommonDocsAction";
// import { findcountryMasterAddAction } from "../../../actions/countryMasterAction";
// import {
//   changeSopApplicationStatusAction,
//   countryAllAdmissionDocsFindAction,
//   leadCountryCommonDocsFindDocsAction,
//   leadCountrycommonDocUploadingAction,
//   leadCountrySpecificDocsFindingDocsAction,
//   leadCountrySpecificDocUploadingAction,
//   leadDocReUploadingAction,
//   leadDocumentDeleteAction,
//   leadOtherDocDeleteAction,
//   leadOtherDocFindAction,
//   leadOtherDocUploadingAction
// } from "../../../actions/leadActions/leadDocsActions";

// const CountryDocs = ({ handleCompleteTick }) => {
//   const dispatch = useDispatch();
//   const { id } = useParams();
//   const [hoveredIcon, setHoveredIcon] = useState(null);
//   const [statusVerify, setStatusVerify] = useState({});
//   const [docStatusVerify, setDocStatusVerify] = useState({});
//   const [open, setOpen] = useState(false);
//   const [otherDocOpenView, setOtherDocOpenView] = useState(false);
//   const [commonDocList, setCommonDocList] = useState([]);
//   const [countryId, setCountryId] = useState(null);

//   // Selectors
//   const {
//     commonDocFindSuccess,
//     countryAdmissionFindSuccess,
//     leadCountryCommonDocsFindSuccess,
//     leadCountryCommonDocsUploadingSuccess,
//     leadCountrySpecificDocsFindingSuccess,
//     leadCountrySpecificDocsUploadingSuccess,
//     leadOtherDocsFindSuccess,
//     leadOtherDocsUploadingSuccess,
//     leadOtherDocsDeleteSuccess,
//     leadDocumentDeleteSuccess,
//   } = useSelector(state => ({
//     commonDocFindSuccess: state.CommonDocumentApplicationFind.commonDocFindSuccess,
//     countryAdmissionFindSuccess: state.countryAllAdmissionDocsFind.countryAdmissionFindSuccess,
//     leadCountryCommonDocsFindSuccess: state.leadCountryCommonDocsFindDocs.leadCountryCommonDocsFindSuccess,
//     leadCountryCommonDocsUploadingSuccess: state.leadCountrycommonDocUploading.leadCountryCommonDocsUploadingSuccess,
//     leadCountrySpecificDocsFindingSuccess: state.leadCountrySpecificDocsFindingDocs.leadCountrySpecificDocsFindingSuccess,
//     leadCountrySpecificDocsUploadingSuccess: state.leadCountrySpecificDocUploading.leadCountrySpecificDocsUploadingSuccess,
//     leadOtherDocsFindSuccess: state.leadOtherDocFind.leadOtherDocsFindSuccess,
//     leadOtherDocsUploadingSuccess: state.leadOtherDocUploading.leadOtherDocsUploadingSuccess,
//     leadOtherDocsDeleteSuccess: state.leadOtherDocDelete.leadOtherDocsDeleteSuccess,
//     leadDocumentDeleteSuccess: state.leadDocumentDelete.leadDocumentDeleteSuccess,
//   }));

//   // Memoized derived state
//   const commonAddedDoc = useMemo(() => {
//     const uniqueIds = new Set();
//     return leadCountryCommonDocsFindSuccess?.filter(doc => {
//       if (!uniqueIds.has(doc.CommonDocId)) {
//         uniqueIds.add(doc.CommonDocId);
//         return true;
//       }
//       return false;
//     }) || [];
//   }, [leadCountryCommonDocsFindSuccess]);

//   const countrySpecificAddedDoc = useMemo(() => {
//     const uniqueIds = new Set();
//     return leadCountrySpecificDocsFindingSuccess?.filter(doc => {
//       if (!uniqueIds.has(doc.DocId)) {
//         uniqueIds.add(doc.DocId);
//         return true;
//       }
//       return false;
//     }) || [];
//   }, [leadCountrySpecificDocsFindingSuccess]);

//   const commonDoc = useMemo(() => 
//     commonDocFindSuccess?.filter(cDoc => 
//       !leadCountryCommonDocsFindSuccess?.some(aDoc => aDoc.CommonDocId === cDoc.id)
//     ) || [],
//     [commonDocFindSuccess, leadCountryCommonDocsFindSuccess]
//   );

//   const countryDoc = useMemo(() => 
//     countryAdmissionFindSuccess?.filter(cDoc => 
//       !leadCountrySpecificDocsFindingSuccess?.some(aDoc => aDoc.DocId === cDoc.id)
//     ) || [],
//     [countryAdmissionFindSuccess, leadCountrySpecificDocsFindingSuccess]
//   );

//   // Effects
//   useEffect(() => {
//     dispatch(countryAllAdmissionDocsFindAction(id));
//     dispatch(CommonDocumentApplicationFindAction());
//     dispatch(findcountryMasterAddAction(id));
//   }, [dispatch, id]);

//   useEffect(() => {
//     if (leadCountryCommonDocsUploadingSuccess || leadDocumentDeleteSuccess) {
//       dispatch(leadCountryCommonDocsFindDocsAction(id));
//     }
//   }, [dispatch, id, leadCountryCommonDocsUploadingSuccess, leadDocumentDeleteSuccess]);

//   useEffect(() => {
//     if (leadCountrySpecificDocsUploadingSuccess || leadDocumentDeleteSuccess) {
//       dispatch(leadCountrySpecificDocsFindingDocsAction(id));
//     }
//   }, [dispatch, id, leadCountrySpecificDocsUploadingSuccess, leadDocumentDeleteSuccess]);

//   useEffect(() => {
//     if (leadOtherDocsUploadingSuccess || leadOtherDocsDeleteSuccess) {
//       dispatch(leadOtherDocFindAction(id));
//     }
//   }, [dispatch, id, leadOtherDocsUploadingSuccess, leadOtherDocsDeleteSuccess]);

//   // Handlers
//   const handleUpload = useCallback((files, action, ...args) => {
//     if (files.length > 6) {
//       alert("Maximum 6 files allowed");
//       return;
//     }

//     Promise.all(
//       Array.from(files).map(file => 
//         new Promise(resolve => {
//           const reader = new FileReader();
//           reader.onloadend = () => resolve(reader.result);
//           reader.readAsDataURL(file);
//         })
//       )
//     ).then(results => dispatch(action(results, ...args)));
//   }, [dispatch]);

//   const handleUploadCommonDocs = useCallback((e, CommonDocId, countryName) => {
//     handleUpload(e.target.files, leadCountrycommonDocUploadingAction, countryId, countryName.id, id);
//   }, [handleUpload, countryId, id]);

//   const handleCountrySpecificDoc = useCallback((e, DocId, data) => {
//     handleUpload(e.target.files, leadCountrySpecificDocUploadingAction, DocId, id, data);
//   }, [handleUpload, id]);

//   const handleOtherDocument = useCallback((e) => {
//     const formData = new FormData();
//     const user = JSON.parse(localStorage.getItem("loginInfo") || "{}");
    
//     Array.from(e.target.files).forEach(file => formData.append("image", file));
//     formData.append("leadId", id);
//     formData.append("taskowner", user?.name || "");

//     dispatch(leadOtherDocUploadingAction(formData));
//   }, [dispatch, id]);

//   const handleDelete = useCallback((docId, type) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!"
//     }).then(result => {
//       if (result.isConfirmed) {
//         dispatch(leadDocumentDeleteAction(docId, id, type));
//         Swal.fire("Deleted!", "Your file has been deleted.\u{1F44D}", "success");
//       }
//     });
//   }, [dispatch, id]);

//   const handleStatusChange = useCallback((leadId, docId, status, type) => {
//     dispatch(changeSopApplicationStatusAction(leadId, docId, status, type));
//   }, [dispatch]);

//   // Styling
//   const iconStyle = {
//     width: "22px",
//     height: "22px",
//     marginRight: "10px",
//     transition: "color 0.3s ease"
//   };

//   const handleMouseEnter = useCallback(icon => setHoveredIcon(icon), []);
//   const handleMouseLeave = useCallback(() => setHoveredIcon(null), []);

//   // Render helpers
//   const renderUploadBox = (data, type) => (
//     <Box sx={{
//       height: 82,
//       bgcolor: "white",
//       border: "1.5px dashed rgba(25, 118, 210, 0.5)",
//       borderRadius: 1,
//       p: 1.5
//     }}>
//       <label htmlFor={`${type}-${data.id}`} style={{ 
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "center",
//         cursor: "pointer",
//         height: "100%"
//       }}>
//         <Box display="flex" alignItems="center">
//           <img src="/menuIcons/docs.png" alt="doc" style={{ width: 40, height: 40 }} />
//           <Box ml={1.25}>
//             <Typography>{data.DocName}</Typography>
//             {type === 'country' && (
//               <Typography variant="caption" color="textSecondary">
//                 {data.Country_Doc?.DocName.split("(")[0]}
//               </Typography>
//             )}
//           </Box>
//         </Box>
//         <Box display="flex" alignItems="center">
//           <img src="/menuIcons/uploadBlue.png" alt="upload" />
//           <Typography color="primary" ml={1}>Upload</Typography>
//         </Box>
//       </label>
//       <input
//         type="file"
//         multiple
//         hidden
//         id={`${type}-${data.id}`}
//         onChange={type === 'common' ? 
//           e => handleUploadCommonDocs(e, data.id, data) : 
//           e => handleCountrySpecificDoc(e, data.id, data)
//         }
//       />
//     </Box>
//   );

//   const renderStatusChips = (doc, index, type) => (
//     <Box sx={{
//       position: "absolute",
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       backdropFilter: "blur(8px)",
//       gap: 2,
//       opacity: 0,
//       transition: "opacity 0.3s",
//       "&:hover": { opacity: 1 }
//     }}>
//       <Chip
//         label="Reupload"
//         color="warning"
//         variant="outlined"
//         onClick={() => {
//           handleStatusChange(doc.leadId, type === 'common' ? doc.CommonDocId : doc.DocId, "reupload", type);
//           type === 'common' ? setStatusVerify({...statusVerify, [index]: false}) : setDocStatusVerify({...docStatusVerify, [index]: false});
//         }}
//       />
//       <Chip
//         label="Verify"
//         color="success"
//         variant="outlined"
//         onClick={() => {
//           handleStatusChange(doc.leadId, type === 'common' ? doc.CommonDocId : doc.DocId, "verified", type);
//           type === 'common' ? setStatusVerify({...statusVerify, [index]: false}) : setDocStatusVerify({...docStatusVerify, [index]: false});
//         }}
//       />
//       <Chip
//         label="Close"
//         color="error"
//         variant="outlined"
//         onClick={() => type === 'common' ? 
//           setStatusVerify({...statusVerify, [index]: false}) : 
//           setDocStatusVerify({...docStatusVerify, [index]: false})
//         }
//       />
//     </Box>
//   );

//   const renderActionIcons = (doc, index, type) => (
//     <>
//       <Tooltip title="View">
//         <IconButton onClick={() => setOpen(true)}>
//           <IoEyeOutline style={{...iconStyle, color: hoveredIcon === 'view' ? 'red' : 'black'}} />
//         </IconButton>
//       </Tooltip>

//       {doc.status !== 'approved' && (
//         <Tooltip title="Change Status">
//           <IconButton onClick={() => type === 'common' ? 
//             setStatusVerify({...statusVerify, [index]: true}) : 
//             setDocStatusVerify({...docStatusVerify, [index]: true})}>
//             <CiRepeat style={{...iconStyle, color: hoveredIcon === 'repeat' ? 'red' : 'black'}} />
//           </IconButton>
//         </Tooltip>
//       )}

//       <Tooltip title="Download">
//         <a href={doc.pdfUrl} download>
//           <IconButton>
//             <GoDownload style={{...iconStyle, color: hoveredIcon === 'download' ? 'red' : 'black'}} />
//           </IconButton>
//         </a>
//       </Tooltip>

//       {!['verified', 'approved'].includes(doc.status) && (
//         <Tooltip title="Delete">
//           <IconButton onClick={() => handleDelete(doc.id, type === 'common' ? 'commonDocs' : 'countryDoc')}>
//             <AiTwotoneDelete style={{...iconStyle, color: hoveredIcon === 'delete' ? 'red' : 'black'}} />
//           </IconButton>
//         </Tooltip>
//       )}
//     </>
//   );

//   return (
//     <Box p={2}>
//       {/* Common Documents Section */}
//       <Typography variant="h6" gutterBottom>Document</Typography>
//       <Grid container spacing={2}>
//         {commonDoc.map(data => (
//           <Grid item xs={12} sm={6} md={4} key={data.id}>
//             {renderUploadBox(data, 'common')}
//           </Grid>
//         ))}

//         {commonAddedDoc.map((doc, index) => (
//           <Grid item xs={12} sm={6} md={4} key={doc.id}>
//             <Box position="relative" sx={{
//               height: 82,
//               bgcolor: "white",
//               border: "1.5px dashed rgba(255, 153, 0, 1)",
//               borderRadius: 2,
//               p: 2
//             }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center">
//                 <Box display="flex" alignItems="center">
//                   <img src="/menuIcons/docs.png" alt="doc" style={{ width: 40, height: 40 }} />
//                   <Box ml={2}>
//                     <Typography>{doc.Common_Doc.DocName}</Typography>
//                     <Box display="flex">
//                       {renderActionIcons(doc, index, 'common')}
//                     </Box>
//                   </Box>
//                 </Box>
//                 <Box textAlign="right">
//                   <Typography color="success.main">Uploaded</Typography>
//                   <Typography color={doc.status === 'verified' ? 'success.main' : 'warning.main'}>
//                     {doc.status}
//                   </Typography>
//                 </Box>
//               </Box>
//               {statusVerify[index] && renderStatusChips(doc, index, 'common')}
//             </Box>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Country Documents Section */}
//       <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>Country Document</Typography>
//       <Grid container spacing={2}>
//         {countryDoc.map(data => (
//           <Grid item xs={12} sm={6} md={4} key={data.id}>
//             {renderUploadBox(data, 'country')}
//           </Grid>
//         ))}

//         {countrySpecificAddedDoc.map((doc, index) => (
//           <Grid item xs={12} sm={6} md={4} key={doc.id}>
//             <Box position="relative" sx={{
//               height: 82,
//               bgcolor: "white",
//               border: "1.5px dashed rgba(255, 153, 0, 1)",
//               borderRadius: 2,
//               p: 2
//             }}>
//               <Box display="flex" justifyContent="space-between" alignItems="center">
//                 <Box display="flex" alignItems="center">
//                   <CountryFlag countryCode={doc.countryCode} width={40} height={40} />
//                   <Box ml={2}>
//                     <Typography>{doc.docName}</Typography>
//                     <Box display="flex">
//                       {renderActionIcons(doc, index, 'country')}
//                     </Box>
//                   </Box>
//                 </Box>
//                 <Box textAlign="right">
//                   <Typography color="success.main">Uploaded</Typography>
//                   <Typography color={doc.status === 'verified' ? 'success.main' : 'warning.main'}>
//                     {doc.status}
//                   </Typography>
//                 </Box>
//               </Box>
//               {docStatusVerify[index] && renderStatusChips(doc, index, 'country')}
//             </Box>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Other Documents Section */}
//       <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>Other Document</Typography>
//       <Grid container spacing={2}>
//         <Grid item xs={12} sm={6} md={4}>
//           <Box sx={{
//             height: 82,
//             bgcolor: "white",
//             border: "1.5px dashed rgba(25, 118, 210, 0.5)",
//             borderRadius: 1,
//             p: 1.5
//           }}>
//             <label htmlFor="other-doc" style={{ 
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               cursor: "pointer",
//               height: "100%"
//             }}>
//               <Box display="flex" alignItems="center">
//                 <img src="/menuIcons/docs.png" alt="doc" style={{ width: 40, height: 40 }} />
//                 <Typography ml={2}>Other Document</Typography>
//               </Box>
//               <Box display="flex" alignItems="center">
//                 <img src="/menuIcons/uploadBlue.png" alt="upload" />
//                 <Typography color="primary" ml={1}>Upload</Typography>
//               </Box>
//             </label>
//             <input
//               type="file"
//               multiple
//               hidden
//               id="other-doc"
//               onChange={handleOtherDocument}
//             />
//           </Box>
//         </Grid>
//       </Grid>

//       {/* Dialogs */}
//       <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
//         <DialogTitle>Document Preview</DialogTitle>
//         <DialogContent dividers>
//           <Grid container spacing={2}>
//             {commonDocList?.map((item, index) => (
//               <Grid item xs={12} key={index}>
//                 <Paper elevation={1} sx={{ p: 2, display: 'flex', justifyContent: 'space-between' }}>
//                   <Typography>Document {index + 1}</Typography>
//                   <a href={item.pdfUrl} download>
//                     <GoDownload style={{ cursor: 'pointer' }} />
//                   </a>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpen(false)}>Close</Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default React.memo(CountryDocs);

import React, { useEffect, useState } from "react";
import {
  Chip,
  Divider,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography
} from "@mui/material";
import { Box } from "@mui/system";

import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import { CiRepeat } from "react-icons/ci";
import { GoDownload } from "react-icons/go";
import { AiTwotoneDelete } from "react-icons/ai";

import { CommonDocumentApplicationFindAction } from "../../../actions/knowledgeBankActions/CommonDocsAction";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { findcountryMasterAddAction } from "../../../actions/countryMasterAction";
import {
  changeSopApplicationStatusAction,
  countryAllAdmissionDocsFindAction,
  leadCountryCommonDocsFindDocsAction,
  leadCountrycommonDocUploadingAction,
  leadCountrySpecificDocsFindingDocsAction,
  leadCountrySpecificDocUploadingAction,
  leadDocReUploadingAction,
  leadDocumentDeleteAction,
  leadOtherDocDeleteAction,
  leadOtherDocFindAction,
  leadOtherDocUploadingAction
} from "../../../actions/leadActions/leadDocsActions";

import "./CountryDocs.css";
import CountryFlag from "../../customComponent/CountryFlag";
import Swal from "sweetalert2";
import {
  LEAD_COUNTRY_COMMON_DOCS_UPLOADING_SUCCESS,
  LEAD_COUNTRY_SPECIFIC_DOCS_UPLOADING_SUCCESS,
  LEAD_DOCUMENT_DELETE_SUCCESS,
  LEAD_OTHER_DOCUMENT_UPLOADING_SUCCESS
} from "../../../constants/leadConstant";

function CountryDocs({ handleNext, handleCompleteTick }) {
  const [hoveredIcon, setHoveredIcon] = useState(null);

  const handleMouseEnter = (icon) => setHoveredIcon(icon);
  const handleMouseLeave = () => setHoveredIcon(null);

  const iconStyle = {
    width: "22px",
    height: "22px",
    marginRight: "10px",
    transition: "color 0.3s ease" // Smooth color transition
  };

  const iconHoverStyle = {
    color: "red" // Color on hover
  };

  let { id } = useParams();
  const dispatch = useDispatch();
  const [countryList, setCountryList] = useState([]);
  const [countryDoc, setCountryDoc] = useState([]);
  const [commonDoc, setCommonDoc] = useState([]);
  const [commonAddedDoc, setCommonAddedDoc] = useState([]);
  const [countrySpecificAddedDoc, setCountrySpeficAddedDoc] = useState([]);
  const [CountryId, setCountryId] = useState();
  const [uplodedOtherDoc, setUplodedOtherDoc] = useState([]);

  let { commonDocFindSuccess } = useSelector((state) => {
    return state.CommonDocumentApplicationFind;
  });

  let { countryFindLoading, countryFindSuccess } = useSelector((state) => {
    return state.findcountryMasterAdd;
  });

  let {
    countryAdmissionFindLoading,
    countryAdmissionFindSuccess,
    countryAdmissionFinderror
  } = useSelector((state) => {
    return state.countryAllAdmissionDocsFind;
  });

  let {
    leadCountryCommonDocsFindLoading,
    leadCountryCommonDocsFindSuccess,
    leadCountryCommonDocsFinderror
  } = useSelector((state) => {
    return state.leadCountryCommonDocsFindDocs;
  });

  let {
    leadCountryCommonDocsUploadingLoading,
    leadCountryCommonDocsUploadingSuccess,
    leadCountryCommonDocsUploadingerror
  } = useSelector((state) => {
    return state.leadCountrycommonDocUploading;
  });

  let {
    leadCountrySpecificDocsFindingLoading,
    leadCountrySpecificDocsFindingSuccess,
    leadCountrySpecificDocsFindingerror
  } = useSelector((state) => {
    return state.leadCountrySpecificDocsFindingDocs;
  });

  let {
    leadCountrySpecificDocsUploadingLoading,
    leadCountrySpecificDocsUploadingSuccess,
    leadCountrySpecificDocsUploadingerror
  } = useSelector((state) => {
    return state.leadCountrySpecificDocUploading;
  });

  let { leadOtherDocsFindSuccess } = useSelector((state) => {
    return state.leadOtherDocFind;
  });

  let { leadOtherDocsUploadingSuccess } = useSelector((state) => {
    return state.leadOtherDocUploading;
  });

  let { leadOtherDocsDeleteSuccess } = useSelector((state) => {
    return state.leadOtherDocDelete;
  });

  let { leadSopStatusChangeSuccess } = useSelector((state) => {
    return state.changeSopApplicationStatus;
  });

  let { leadDocumentDeleteSuccess } = useSelector((state) => {
    return state.leadDocumentDelete;
  });

  // Reupload successState

  let { leadDocumentReUploadingSuccess } = useSelector((state) => {
    return state.leadDocumentReupload;
  });

  useEffect(() => {
    dispatch(countryAllAdmissionDocsFindAction(id));
  }, [
    dispatch,
    // leadCountryCommonDocsUploadingSuccess,
    leadCountrySpecificDocsUploadingSuccess,
    id,
    leadSopStatusChangeSuccess
  ]);

  useEffect(() => {
    // if (leadSopStatusChangeSuccess || leadDocumentReUploadingSuccess || leadDocumentDeleteSuccess) {
      dispatch(leadCountryCommonDocsFindDocsAction(id));
      dispatch(leadCountrySpecificDocsFindingDocsAction(id));
    // }
  }, [
    dispatch,
    id,
    leadSopStatusChangeSuccess,
    leadDocumentReUploadingSuccess,
    leadDocumentDeleteSuccess
  ]);

  useEffect(() => {
    if (commonDocFindSuccess) {
      setCountryList(commonDocFindSuccess);
    }
  }, [commonDocFindSuccess]);

  useEffect(() => {
    if (leadCountryCommonDocsFindSuccess) {
      const uniqueDocumentIds = new Set();
      setCommonAddedDoc(
        leadCountryCommonDocsFindSuccess?.filter((specificData) => {
          if (!uniqueDocumentIds.has(specificData.CommonDocId)) {
            uniqueDocumentIds.add(specificData.CommonDocId);
            return true;
          }
          return false;
        })
      );
    }
  }, [leadCountryCommonDocsFindSuccess]);

  useEffect(() => {
    if (leadCountrySpecificDocsFindingSuccess) {
      const uniqueDocumentIds = new Set();
      setCountrySpeficAddedDoc(
        leadCountrySpecificDocsFindingSuccess?.filter((specificData) => {
          if (!uniqueDocumentIds.has(specificData.DocId)) {
            uniqueDocumentIds.add(specificData.DocId);
            return true;
          }
          return false;
        })
      );
    }
  }, [leadCountrySpecificDocsFindingSuccess]);

  useEffect(() => {
    if (leadCountryCommonDocsFindSuccess && commonDocFindSuccess) {
      const notEqualCountries = commonDocFindSuccess.filter((country) => {
        return !leadCountryCommonDocsFindSuccess.some(
          (sop) => country.id == sop.CommonDocId
        );
      });
      setCommonDoc(notEqualCountries);
    }
  }, [commonDocFindSuccess, leadCountryCommonDocsFindSuccess]);

  useEffect(() => {
    if (countryAdmissionFindSuccess && leadCountrySpecificDocsFindingSuccess) {
      const filterCountryDocs = countryAdmissionFindSuccess?.filter(
        (country) => {
          return !leadCountrySpecificDocsFindingSuccess.some(
            (sop) => country.id == sop.DocId
          );
        }
      );
      setCountryDoc(filterCountryDocs);
    }
  }, [countryAdmissionFindSuccess, leadCountrySpecificDocsFindingSuccess]);

  useEffect(() => {
    dispatch(CommonDocumentApplicationFindAction());
    dispatch(findcountryMasterAddAction(id));
  }, [
    dispatch,
    id
    // leadCountrySpecificDocsUploadingSuccess,
    // leadCountryCommonDocsUploadingSuccess,
    // leadSopStatusChangeSuccess,
    // leadDocumentReUploadingSuccess
  ]);

  // useEffect(() => {
  //   dispatch(findcountryMasterAddAction(id));
  // }, [
    // dispatch,
    // leadCountrySpecificDocsUploadingSuccess,
    // leadCountryCommonDocsUploadingSuccess,
    // leadSopStatusChangeSuccess
  // ]);
  

  // useEffect(() => {
  //   dispatch(leadCountrySpecificDocsFindingDocsAction(id));
  // }, [
  //   dispatch,
  //   id,
  //   leadCountrySpecificDocsUploadingSuccess,
  //   // leadCountryCommonDocsUploadingSuccess,
  //   leadSopStatusChangeSuccess,
  //   leadDocumentReUploadingSuccess,
  //   leadDocumentDeleteSuccess
  // ]);

  useEffect(() => {
    dispatch(leadOtherDocFindAction(id));
  }, [
    dispatch,
    leadOtherDocsUploadingSuccess,
    uplodedOtherDoc,
    leadOtherDocsDeleteSuccess
  ]);
  
  useEffect(() => {
    if (leadOtherDocsUploadingSuccess) {
      Swal.fire({
        icon: "success",
        title: "Good job \u{1F44D} ",
        text: "Other Document Uploaded Successfully"
      });
      // dispatch({
      //   type: LEAD_OTHER_DOCUMENT_UPLOADING_SUCCESS,
      //   payload: false
      // });
    }
  }, [leadOtherDocsUploadingSuccess]);

  // useEffect(() => {
  //   if (
  //     countryAdmissionFindSuccess !== undefined &&
  //     countryAdmissionFindSuccess.length !== 0
  //   ) {
  //     if (commonDoc.length === 0 && countryDoc.length === 0) {
  //       handleCompleteTick();
  //     }
  //   }
  // }, [commonDoc, countryDoc, handleCompleteTick, countryAdmissionFindSuccess]);

  // useEffect(()=>{

  // },[leadDocumentReUploadingSuccess])

  const handleUploadCommonDocsChange = async (event, CommonDocId, countryName) => {
    const selectedFiles = event.target.files;

    if (selectedFiles.length > 6) {
      alert("You can select only 6 files.");
      return;
    }

    try {

      const fileReadPromises = [...selectedFiles].map(file =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(file);
        })
      );

      const results = await Promise.all(fileReadPromises);

      dispatch(
        leadCountrycommonDocUploadingAction(
          results,
          CountryId,
          countryName.id,
          id
        )
      );

    } catch (error) {
      console.error("Error reading files:", error);
    }
  };

  // country Doc changer

  const handleCountrySpecificDocChange = (event, DocId, data) => {
    const files = event.target.files;

    if (files && files.length <= 6) {
      // Read each image file as a data URL
      const readers = Array.from(files).map((file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        return reader;
      });

      Promise.all(
        readers.map(
          (reader) =>
            new Promise((resolve, reject) => {
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = () => reject(new Error("Error reading file"));
            })
        )
      )
        .then((results) => {
          dispatch(
            leadCountrySpecificDocUploadingAction(results, DocId, id, data)
          );
        })
        .catch((error) => {
          console.error("Error reading files: ", error);
        });
    } else {
      console.error("No files selected or too many files (more than 6)");
    }
  };

  const handleCountrySpecificDocReupload = (event, DocId, data) => {
    const files = event.target.files[0];
    let status;

    if (data.Common_Doc) {
      status = "CommonDoc";
    } else {
      status = "CountryDoc";
    }
    // Read each image file as a data URL
    const reader = new FileReader();
    reader.readAsDataURL(files);

    reader.onloadend = () => {
      dispatch(leadDocReUploadingAction(reader.result, DocId, data, status));
    };
  };

  // document visible click
  const [open, setOpen] = React.useState(false);
  const [otherDocOpenView, setOtherDocOpenView] = React.useState(false);

  const [numPages, setNumPages] = useState(null);
  const [url, setUrl] = React.useState("");
  const [scroll, setScroll] = React.useState("paper");
  const [statusVerify, setStatusVerify] = useState(false);
  const [docStatusVerify, setDocStatusVerify] = useState(false);
  const [commonDocList, setCommonDocList] = useState([]);
  const [listDocuments, setListDocuments] = useState([]);

  const handleClickOpen = (scrollType, pdfUrl, CommonDocId, section) => () => {
    // alert(CommonDocId);
    let listDoc;
    if (section === "country") {
      listDoc =
        leadCountrySpecificDocsFindingSuccess &&
        leadCountrySpecificDocsFindingSuccess?.filter(
          (item) => item.DocId === CommonDocId
        );
    } else {
      listDoc =
        leadCountryCommonDocsFindSuccess &&
        leadCountryCommonDocsFindSuccess?.filter(
          (item) => item.CommonDocId === CommonDocId
        );
    }

    setCommonDocList(listDoc);
    setUrl(pdfUrl);
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
    setCommonDocList([]);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open, otherDocOpenView]);
  
  useEffect(() => {
    if (leadCountryCommonDocsUploadingSuccess) {
      Swal.fire({
        icon: "success",
        title: "Good job \u{1F44D} ",
        text: "Document Uploaded Successfully"
      });
      dispatch({ type: LEAD_COUNTRY_COMMON_DOCS_UPLOADING_SUCCESS, payload: false });
      dispatch(leadCountryCommonDocsFindDocsAction(id));
    }

    if (leadCountrySpecificDocsUploadingSuccess) {
      Swal.fire({
        icon: "success",
        title: "Good job \u{1F44D} ",
        text: "Document Uploaded Successfully"
      });
      dispatch({ type: LEAD_COUNTRY_SPECIFIC_DOCS_UPLOADING_SUCCESS, payload: false });
      dispatch(leadCountrySpecificDocsFindingDocsAction(id));
    }
  }, [
    dispatch,
    id,
    leadCountryCommonDocsUploadingSuccess,
    leadCountrySpecificDocsUploadingSuccess
  ]);

  // Other Document upload

  // const handleOtherDocumentChange = (event) => {    
  //   let isUserExist = localStorage.getItem("loginInfo")
  //     ? JSON.parse(localStorage.getItem("loginInfo"))
  //     : null;
  //   let taskOwner = isUserExist?.name;

  //   const files = event.target.files;
  //   console.log(972,files);
  //   if (files && files.length > 0) {

      
  //     setUplodedOtherDoc(Array.from(event));
  //     // Read each image file as a data URL
  //     const formData = new FormData();
  //     Array.from(event)?.forEach((file, index) => {
  //       formData.append("image", files);
  //     });
  //     formData.append("leadId", id);
  //     formData.append("taskowner", taskOwner);

  //     console.log(980,formData);

  //     for (let pair of formData.entries()) {
  //       console.log(980,"loop",pair[0], pair[1]);
  //     }

  //     dispatch(leadOtherDocUploadingAction(formData));
  //   } else {
  //     console.error("No files selected or too many files (more than 6)");
  //   }
  // };

  const handleOtherDocumentChange = (event) => {
    const isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;
    const taskOwner = isUserExist?.name;
  
    const files = event.target.files;
  
    if (files && files.length <= 6) {
      setUplodedOtherDoc(Array.from(files)); // Optional: for preview or tracking
  
      // Create FileReader promises for each file
      const readers = Array.from(files).map((file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        return reader;
      });
  
      Promise.all(
        readers.map(
          (reader) =>
            new Promise((resolve, reject) => {
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = () => reject(new Error("Error reading file"));
            })
        )
      )
        .then((results) => {  
          dispatch(
            leadOtherDocUploadingAction(results, id, taskOwner)
          );
        })
        .catch((error) => {
          console.error("Error reading files: ", error);
        });
    } else {
      console.error("No files selected or too many files (more than 6)");
    }
  };
  

  const handleDelete = (addedDoc) => {    
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(
            leadDocumentDeleteAction(
              addedDoc,
              id,
              "commonDocs"
            )
          );
          Swal.fire(
            "Deleted!",
            "Your file has been deleted.\u{1F44D}",
            "success"
          );
        }
      });
    } catch(error) {
      console.error(error);
    }
  }

  const handleDeleteCountryDocument = (specificData) => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(
            leadDocumentDeleteAction(
              specificData,
              id,
              "countryDoc"
            )
          );
          Swal.fire(
            "Deleted!",
            "Your file has been deleted.\u{1F44D}",
            "success"
          );
        }
      });
    } catch(error) {
      console.error(error);
    }
  }

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} sx={{ mb: 1, mt: 1 }}>
          <Typography sx={{ fontWeight: 700 }} variant="h6">
            Document
          </Typography>
        </Grid>

        {commonDoc?.length == 0 &&
        countryDoc?.lengtth == 0 &&
        commonAddedDoc?.length == 0 &&
        countrySpecificAddedDoc?.length == 0 ? (
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "18px",
              lineHeight: "24px",
              fontFamily: "Montserrat,sans-serif",
              textAlign: "center",
              mt: 10,
              ml: 5,
              mt: 5
            }}
          >
            No documents to show. Preferred country is required to show
            Documents !
          </Typography>
        ) : (
          ""
        )}
        {commonDoc?.map((data) => (
          <Grid item xs={6} md={4} lg={3} key={data?.id}>
            <Box
              sx={{
                height: 82,
                bgcolor: "white",
                border: "1.5px dashed rgba(25, 118, 210, 0.5)",
                borderRadius: 1
              }}
            >
              <label
                htmlFor={`commonDoc_file${data?.id}`}
                style={{ 
                  margin: 15,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer"
                }}
                onClick={() => setCountryId(data.id)}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="/menuIcons/docs.png"
                    alt="gsl"
                    width={39}
                    height={42}
                  />
                  <Typography sx={{ fontSize: '14px' }}>
                    {data.DocName}
                  </Typography>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="/menuIcons/uploadBlue.png"
                    alt="gsl_download"
                    // style={{ cursor: "pointer", color: "#1976D2" }}
                  />
                  <Typography color="primary" ml={1} fontFamily="Montserrat">
                    Upload
                  </Typography>
                </div>
              </label>

            <input
              type="file"
              accept=".pdf,.doc,.docx,.xlsx"
              id={`commonDoc_file${data?.id}`}
              style={{ display: "none" }}
              multiple
              onChange={(e) => handleUploadCommonDocsChange(e, data.id, data)}
              />
              </Box>
          </Grid>
        ))}

{commonAddedDoc?.map((addedDoc, index) => (
  <Grid item xs={6} md={4} lg={3} key={index}>
    <Box mt={1} mb={5} position="relative">
      <Box
        sx={{
          height: 82,
          bgcolor: "white",
          border: "1.5px dashed rgba(255, 153, 0, 1)",
          borderRadius: 2
        }}
      >
        <Box display="flex" justifyContent="space-between" m={1.25}>
          <Box display="flex" alignItems="center">
            <img
              src="/menuIcons/docs.png"
              alt="gsl"
              width={39}
              height={39}
            />
            <Box ml={1.25}>
              <Typography sx={{ fontSize: '14px' }}>
                {addedDoc.Common_Doc.DocName}
              </Typography>
              <Box display="flex">
                {!statusVerify[index] && (
                  <>
                    <Tooltip title="view">
                      <IconButton sx={{ p: 0, mr: 1 }}>
                        <IoEyeOutline
                          style={{
                            ...iconStyle,
                            color: hoveredIcon === "eye" ? iconHoverStyle.color : "inherit",
                            cursor: "pointer"
                          }}
                          onMouseEnter={() => handleMouseEnter("eye")}
                          onMouseLeave={handleMouseLeave}
                          onClick={handleClickOpen(
                            "paper",
                            addedDoc.pdfUrl,
                            addedDoc.CommonDocId,
                            "common"
                          )}
                        />
                      </IconButton>
                    </Tooltip>

                    {addedDoc.status !== "approved" && (
                      <Tooltip title="Change status">
                        <IconButton sx={{ p: 0, mr: 1 }}>
                          <CiRepeat
                            style={{
                              ...iconStyle,
                              color: hoveredIcon === "repeat" ? iconHoverStyle.color : "inherit",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() => handleMouseEnter("repeat")}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => setStatusVerify(prev => ({ ...prev, [index]: true }))}
                          />
                        </IconButton>
                      </Tooltip>
                    )}

                    <a
                      href={addedDoc.pdfUrl}
                      download={addedDoc.pdfUrl}
                      target="blank"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <Tooltip title="Download">
                        <IconButton sx={{ p: 0, mr: 1 }}>
                          <GoDownload
                            style={{
                              ...iconStyle,
                              color: hoveredIcon === "download" ? iconHoverStyle.color : "inherit",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() => handleMouseEnter("download")}
                            onMouseLeave={handleMouseLeave}
                          />
                        </IconButton>
                      </Tooltip>
                    </a>

                    {addedDoc.status !== "verified" && 
                    addedDoc.status !== "approved" && (
                      <Tooltip title="Delete">
                        <IconButton sx={{ p: 0, mr: 1 }}>
                          <AiTwotoneDelete
                            style={{
                              ...iconStyle,
                              color: hoveredIcon === "delete" ? iconHoverStyle.color : "inherit",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() => handleMouseEnter("delete")}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => handleDelete(addedDoc.id)}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                )}
              </Box>
            </Box>
          </Box>

          <Box display="flex" flexDirection="column" alignItems="flex-end">
            <Typography color="success.main" fontFamily="Montserrat">
              Uploaded
            </Typography>
            <Typography
              color={["verified", "approved"].includes(addedDoc.status) 
                ? "success.main" 
                : "warning.main"}
              textTransform="capitalize"
            >
              {addedDoc.status}
            </Typography>
          </Box>
        </Box>

        {statusVerify[index] && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backdropFilter: "blur(8px)",
              gap: 2,
              opacity: 0,
              transition: "opacity 0.3s",
              zIndex: 1,
              "&:hover": { opacity: 1 }
            }}
          >
            <Chip
              label="Reupload"
              color="warning"
              variant="outlined"
              sx={{ 
                borderColor: "warning.main",
                color: "warning.main",
                cursor: "pointer"
              }}
              onClick={() => {
                dispatch(
                  changeSopApplicationStatusAction(
                    addedDoc.leadId,
                    addedDoc.CommonDocId,
                    "reupload",
                    "Docs"
                  )
                );
                setStatusVerify(prev => ({ ...prev, [index]: false }));
              }}
            />
            <Chip
              label="Verify"
              color="success"
              variant="outlined"
              sx={{
                borderColor: "success.main",
                color: "success.main",
                cursor: "pointer"
              }}
              onClick={() => {
                dispatch(
                  changeSopApplicationStatusAction(
                    addedDoc.leadId,
                    addedDoc.CommonDocId,
                    "verified",
                    "Docs"
                  )
                );
                setStatusVerify(prev => ({ ...prev, [index]: false }));
              }}
            />
            <Chip
              label="Close"
              color="error"
              variant="outlined"
              sx={{ cursor: "pointer" }}
              onClick={() => setStatusVerify(prev => ({ ...prev, [index]: false }))}
            />
          </Box>
        )}
      </Box>
    </Box>
  </Grid>
))}

<Grid item xs={12} sx={{ mb: 1, mt: 1 }}>
  <Typography sx={{ fontWeight: 700 }} variant="h6">
    Country Document
  </Typography>
</Grid>

{countryDoc?.map((data) => (
  <Grid item xs={6} md={4} lg={3} key={data.id}>
    <Box
      sx={{
        height: 82,
        bgcolor: "white",
        border: "1.5px dashed rgba(25, 118, 210, 0.5)",
        borderRadius: 2
      }}
    >
      <label
        htmlFor={`countryDoc-file${data.id}`}
        style={{
          margin: 15,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer"
        }}
      >
        <Box display="flex" alignItems="center">
          <img
            src="/menuIcons/docs.png"
            alt="gsl"
            width={39}
            height={39}
          />
          <Box ml={1.25}>
            <Typography variant="body1">
              {data.docName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {data.Country_Doc.DocName.split("(")[0]}
            </Typography>
          </Box>
        </Box>

        <Box display="flex" alignItems="center">
          <img
            src="/menuIcons/uploadBlue.png"
            alt="upload"
            width={24}
            height={24}
          />
          <Typography color="primary" ml={1} fontFamily="Montserrat">
            Upload
          </Typography>
        </Box>
      </label>

      <input
        type="file"
        accept=".pdf,.doc,.docx,.xlsx"
        id={`countryDoc-file${data.id}`}
        style={{ display: "none" }}
        multiple
        onChange={(e) => handleCountrySpecificDocChange(e, data.id, data)}
      />
    </Box>
  </Grid>
))}

{countrySpecificAddedDoc?.map((specificData, index) => (
  <Grid item xs={6} md={4} lg={3} key={specificData.id}>
    <Box mt={1} mb={5} position="relative">
      <Box
        sx={{
          height: 82,
          bgcolor: "white",
          border: "1.5px dashed rgba(255, 153, 0, 1)",
          borderRadius: 2
        }}
      >
        <Box display="flex" justifyContent="space-between" m={1.25}>
          <Box display="flex" alignItems="center">
            <CountryFlag
              countryCode={specificData.countryCode}
              component="stepper"
              width={39}
              height={39}
            />
            <Box ml={1.25}>
              <Typography variant="body1">
                {specificData.docName}
              </Typography>
              <Box display="flex">
                {!docStatusVerify[index] && (
                  <>
                    <Tooltip title="view">
                      <IconButton sx={{ p: 0, mr: 1 }}>
                        <IoEyeOutline
                          style={{
                            ...iconStyle,
                            color: hoveredIcon === "eye" ? iconHoverStyle.color : "inherit",
                            cursor: "pointer"
                          }}
                          onMouseEnter={() => handleMouseEnter("eye")}
                          onMouseLeave={handleMouseLeave}
                          onClick={handleClickOpen(
                            "paper",
                            specificData.pdfUrl,
                            specificData.DocId,
                            "country"
                          )}
                        />
                      </IconButton>
                    </Tooltip>

                    {specificData.status !== "approved" && (
                      <Tooltip title="Change status">
                        <IconButton sx={{ p: 0, mr: 1 }}>
                          <CiRepeat
                            style={{
                              ...iconStyle,
                              color: hoveredIcon === "repeat" ? iconHoverStyle.color : "inherit",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() => handleMouseEnter("repeat")}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => setDocStatusVerify(prev => ({ ...prev, [index]: true }))}
                          />
                        </IconButton>
                      </Tooltip>
                    )}

                    <a
                      href={specificData.pdfUrl}
                      download={specificData.pdfUrl}
                      target="blank"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <Tooltip title="Download">
                        <IconButton sx={{ p: 0, mr: 1 }}>
                          <GoDownload
                            style={{
                              ...iconStyle,
                              color: hoveredIcon === "download" ? iconHoverStyle.color : "inherit",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() => handleMouseEnter("download")}
                            onMouseLeave={handleMouseLeave}
                          />
                        </IconButton>
                      </Tooltip>
                    </a>

                    {specificData.status !== "verified" && 
                    specificData.status !== "approved" && (
                      <Tooltip title="Delete">
                        <IconButton sx={{ p: 0, mr: 1 }}>
                          <AiTwotoneDelete
                            style={{
                              ...iconStyle,
                              color: hoveredIcon === "delete" ? iconHoverStyle.color : "inherit",
                              cursor: "pointer"
                            }}
                            onMouseEnter={() => handleMouseEnter("delete")}
                            onMouseLeave={handleMouseLeave}
                            onClick={() => handleDeleteCountryDocument(specificData.id)}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                )}
              </Box>
            </Box>
          </Box>

          <Box display="flex" flexDirection="column" alignItems="flex-end">
            <Typography color="success.main" fontFamily="Montserrat">
              Uploaded
            </Typography>
            <Typography
              color={["verified", "approved"].includes(specificData.status) 
                ? "success.main" 
                : "warning.main"}
              textTransform="capitalize"
            >
              {specificData.status}
            </Typography>
          </Box>
        </Box>

        {docStatusVerify[index] && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backdropFilter: "blur(8px)",
              gap: 2,
              opacity: 0,
              transition: "opacity 0.3s",
              zIndex: 1,
              "&:hover": { opacity: 1 }
            }}
          >
            <Chip
              label="Reupload"
              color="warning"
              variant="outlined"
              sx={{ 
                borderColor: "warning.main",
                color: "warning.main",
                cursor: "pointer"
              }}
              onClick={() => {
                dispatch(
                  changeSopApplicationStatusAction(
                    specificData.leadId,
                    specificData.DocId,
                    "reupload",
                    "countryDocs"
                  )
                );
                setDocStatusVerify(prev => ({ ...prev, [index]: false }));
              }}
            />
            <Chip
              label="Verify"
              color="success"
              variant="outlined"
              sx={{
                borderColor: "success.main",
                color: "success.main",
                cursor: "pointer"
              }}
              onClick={() => {
                dispatch(
                  changeSopApplicationStatusAction(
                    specificData.leadId,
                    specificData.DocId,
                    "verified",
                    "countryDocs"
                  )
                );
                setDocStatusVerify(prev => ({ ...prev, [index]: false }));
              }}
            />
            <Chip
              label="Close"
              color="error"
              variant="outlined"
              sx={{ cursor: "pointer" }}
              onClick={() => setDocStatusVerify(prev => ({ ...prev, [index]: false }))}
            />
          </Box>
        )}
      </Box>
    </Box>
  </Grid>
))}

        <Grid item xs={12} sx={{ mb: 1, mt: 1 }}>
          <Typography sx={{ fontWeight: 700 }} variant="h6">
            Other Document
          </Typography>
        </Grid>
      </Grid>

      {leadOtherDocsFindSuccess?.data?.length == 0 ? (
  <Grid item xs={6} md={4} lg={3}>
    <Box sx={{
      height: 82,
      bgcolor: "white",
      border: "1.5px dashed rgba(25, 118, 210, 0.5)",
      borderRadius: 2,
      p: 1.5
    }}>
      <label htmlFor="other-doc-file" style={{ 
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        height: "100%"
      }}>
        <Box display="flex" alignItems="center">
          <img src="/menuIcons/docs.png" alt="doc" style={{ width: 40, height: 40 }} />
          <Typography ml={2}>Other Document</Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <img src="/menuIcons/uploadBlue.png" alt="upload" />
          <Typography color="primary" ml={1}>Upload</Typography>
        </Box>
      </label>
      <input
        type="file"
        multiple
        hidden
        id="other-doc-file"
        onChange={(e) => handleOtherDocumentChange(e)}
      />
    </Box>
  </Grid>
) : (
  <Grid item xs={6} md={4} lg={3}>
    <Box position="relative" sx={{
      height: 82,
      bgcolor: "white",
      border: "1.5px dashed rgba(255, 153, 0, 1)",
      borderRadius: 2,
      p: 2
    }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box display="flex" alignItems="center">
          <img src="/menuIcons/docs.png" alt="doc" style={{ width: 40, height: 40 }} />
          <Box ml={2}>
            <Typography>Other Document</Typography>
            <Box display="flex">
              <Tooltip title="View">
                <IconButton onClick={() => setOtherDocOpenView(true)}>
                  <IoEyeOutline style={{
                    ...iconStyle, 
                    color: hoveredIcon === 'view' ? 'red' : 'black'
                  }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!"
                  }).then((result) => {
                    if (result.isConfirmed) {
                      dispatch(leadOtherDocDeleteAction(id));
                      Swal.fire("Deleted!", "Your file has been deleted.\u{1F44D}", "success");
                    }
                  });
                }}>
                  <AiTwotoneDelete style={{
                    ...iconStyle, 
                    color: hoveredIcon === 'delete' ? 'red' : 'black'
                  }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Box>
        <Box textAlign="right">
          <Typography color="success.main">Uploaded</Typography>
          <Typography color="warning.main">pending</Typography>
        </Box>
      </Box>
    </Box>
  </Grid>
)}

      {/* document visible dilogues */}
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        PaperProps={{
          style: {
            marginTop: "10vh",
            alignSelf: "flex-start",
            width: "100%",
            padding: "20px"
          }
        }}
      >
        <DialogTitle id="scroll-dialog-title">Pdf View</DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            style={{
              padding: "20px"
            }}
          >
            {/* <iframe
              src={url}
              width="100%"
              height="100%"
              title="PDF Preview"
              // sandbox="allow-scripts allow-same-origin"
            /> */}
            {/* <iframe src={url} style={{width:"600px", height:"500px"}} frameBorder="0"/> */}
            <Grid container spacing={2}>
              {commonDocList &&
                commonDocList?.map((item, index) => (
                  <>
                    <Grid item xs={12} key={index}>
                      <Paper
                        elevation={1}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          border: ".5px solid #F9F9FB",
                          padding: "10px"
                        }}
                      >
                        <div>
                          <Typography>Document {index + 1}.pdf</Typography>
                        </div>
                        <div>
                          {/* <label>
                            <img
                              src="/menuIcons/uploadDoc.png"
                              alt="gsl"
                              style={{
                                fontSize: "2em",
                                marginRight: "15px",
                                cursor: "pointer",
                                color: "#f81b82"
                              }}
                            />

                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.xlsx"
                              id="ReUpload-file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleCountrySpecificDocReupload(
                                  e,
                                  item.id,
                                  item
                                );
                              }}
                            />
                          </label> */}
                          <a
                            href={item.pdfUrl}
                            download={item.pdfUrl}
                            target="blank"
                          >
                            <img
                              src="/menuIcons/visibleDoc.png"
                              alt="gsl"
                              style={{
                                fontSize: "2.5em",
                                marginRight: "20px",
                                cursor: "pointer",
                                color: "#f81b82"
                              }}
                              // onClick={handleClickOpen("paper", specificData.pdfUrl)}
                            />
                          </a>

                          {/* <img
                            src="/menuIcons/statusChange.png"
                            alt="gsl"
                            style={{
                              fontSize: "2.5em",
                              marginRight: "10px",
                              cursor: "pointer",
                              color: "#f81b82",
                            }}
                            onClick={() => setDocStatusVerify(true)}
                          /> */}
                        </div>
                      </Paper>
                    </Grid>
                    <Divider />
                  </>
                ))}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Other document visible dilogues */}
      <Dialog
        open={otherDocOpenView}
        onClose={() => setOtherDocOpenView(false)}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        PaperProps={{
          style: {
            marginTop: "10vh",
            alignSelf: "flex-start",
            width: "100%",
            padding: "20px"
          }
        }}
      >
        <DialogTitle id="scroll-dialog-title">Pdf View</DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
            style={{
              padding: "20px"
            }}
          >
            <Grid container spacing={2}>
              {leadOtherDocsFindSuccess &&
                leadOtherDocsFindSuccess?.data?.map((item, index) => (
                  <>
                    <Grid item xs={12} key={index}>
                      <Paper
                        elevation={1}
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          border: ".5px solid #F9F9FB",
                          padding: "10px"
                        }}
                      >
                        <div>
                          <Typography>
                            {item?.documentName?.split(".")[0]}
                          </Typography>
                        </div>
                        <div>
                          <a
                            href={item.pdfUrl}
                            download={item.pdfUrl}
                            target="blank"
                          >
                            <img
                              src="/menuIcons/visibleDoc.png"
                              alt="gsl"
                              style={{
                                fontSize: "2.5em",
                                marginRight: "20px",
                                cursor: "pointer",
                                color: "#f81b82"
                              }}
                            />
                          </a>

                          {/* <img
                            src="/menuIcons/statusChange.png"
                            alt="gsl"
                            style={{
                              fontSize: "2.5em",
                              marginRight: "10px",
                              cursor: "pointer",
                              color: "#f81b82",
                            }}
                            onClick={() => setDocStatusVerify(true)}
                          /> */}
                        </div>
                      </Paper>
                    </Grid>
                    <Divider />
                  </>
                ))}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOtherDocOpenView(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CountryDocs;